import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { makeStyles } from '@material-ui/core/styles';
import SearchMobile from './SearchMobile';
import Hidden from '@material-ui/core/Hidden';

import NavbarContent from './NavbarContent';

const useStyles = makeStyles(theme => ({
  appBar: {
    zIndex: 1002,
    boxShadow: 'none',
  },
  toolbar: {
    width: '100%',
  },
}));

const Navbar = ({ value, setValue, refine }) => {
  const classes = useStyles();

  return (
    <>
      <AppBar position="fixed" className={classes.appBar}>
        <Hidden smDown implementation="css">
          <Toolbar className={classes.toolbar}>
            <NavbarContent isDemo>
              <SearchMobile refine={refine} value={value} setValue={setValue} />
            </NavbarContent>
          </Toolbar>
        </Hidden>
        <Hidden mdUp>
          <Toolbar className={classes.toolbar}>
            <SearchMobile refine={refine} value={value} setValue={setValue} />
          </Toolbar>
        </Hidden>
      </AppBar>
    </>
  );
};

export default Navbar;
